import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  root: {
    '& .MuiTableRow-root': {
      verticalAlign: 'initial',
    },
    '& .MuiPaper-root': {
      [Theme.breakpoints.down('xs')]: {
        width: 'calc(100% - 32px)',
        minWidth: 'calc(100% - 32px)',
        maxWidth: 'calc(100% - 32px)',
      },
    },
    '& .guestName': {
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .guestType': {
      paddingLeft: '5px',
      paddingRight: '20px',
      width: '168px',

      [Theme.breakpoints.down('440')]: {
        width: '118px',
      },
    },
    '& .unaccompaniedMinorError': {
      display: 'block',
      paddingTop: '8px',
      color: Theme.palette.error.main,
    },
    '& .guestSelector': {
      paddingLeft: '15px',
    },
    '& .MuiList-padding': {
      padding: '0px !important',
      [Theme.breakpoints.down('539')]: {
        width: '400px',
      },
      [Theme.breakpoints.down('439')]: {
        width: '100%',
      },
      [Theme.breakpoints.up('540')]: {
        width: '500px',
      },
    },
    '& .onLapOptionSelectorContainer': {
      display: 'grid',
    },
    '& .onLapOptionSelector': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiIconButton-root:first-child': {
        padding: '0',
        marginRight: '5px',
      },
      '& .MuiIconButton-root:last-child': {
        padding: '0',
        marginLeft: '5px',
      },
      '& .infantTypeLabel': {
        width: '110px',

        [Theme.breakpoints.down('440')]: {
          width: '70px',
        },
      },
    },
    '& .guestButtonWrapper': {
      padding: '20px !important',
      '& button span': {
        width: 'fit-content',
        fontFamily: Theme.typography.base.regular,
        fontSize: Theme.typography.size[2],
      },
    },
    '& .MuiIconButton-root': {
      color: Theme.palette.primary.light,
      '&.Mui-disabled': {
        color: Theme.palette.gray[500],
      },
    },

    '& .cancelButton': {
      marginLeft: 'auto',
      color: Theme.palette.primary.light,
    },
    '& .MuiButtonBase-root:not(.MuiCheckbox-root, .MuiIconButton-root, .cancelButton, .doneButton)':
      {
        cursor: 'default',
      },
    '& .MuiTable-root': {
      padding: '14px !important',
      marginBottom: '20px',
      marginTop: '10px',
    },
  },
  menuBody: {
    padding: '0px !important',
    '& p': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      textTransform: 'capitalize',
    },
  },
  label: {
    fontSize: Theme.typography.size[1],
    margin: '0 0 8px 0',
    '&:not([disabled])': {
      color: Theme.palette.primary.light,
    },
  },
}));

export default useStyles;
